module.exports = "<div class=\"editableMultipleFields ml-3 mt-2\">\n  <md-icon\n    class=\"md-primary\"\n    ng-click=\"$ctrl.enableFields()\"\n    ng-if=\"$ctrl.isDisabled\"\n  >\n    edit\n    <md-tooltip md-direction=\"top\">\n      Edit {{$ctrl.fieldTitle || 'Fields'}}\n    </md-tooltip>\n  </md-icon>\n  <md-icon\n    class=\"md-primary\"\n    ng-click=\"$ctrl.submitFields()\"\n    ng-if=\"!$ctrl.isDisabled\"\n  >\n    done\n    <md-tooltip md-direction=\"top\">Confirm Changes</md-tooltip>\n  </md-icon>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/editableMultipleFields/editableMultipleFields.html
// module id = 1106
// module chunks = 0